'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './sub-admin.routes';

export class SubAdminComponent {
  constructor(SubService, dialogs, $uibModal, $stateParams, Auth, DTOptionsBuilder, Config) {
    'ngInject';
    this.SubService = SubService;
    this.data = [];
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;

    this.formName = $stateParams.name;
    this.Auth = Auth;

    this.groups = Config.getModuleConfig(Config.Modules.General).getGroups();

    this.groupNameMap = {};
    this.groups.forEach(group => this.groupNameMap[group.key] = group.name);

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withBootstrap()
      .withOption('responsive', true);

    this.getData();
  }

  getData() {
    this.SubService.query(data => {
      this.data = data;
    }, err => {
      console.log("Could not retrieve external subs.")
    })
  }

  activate(sub) {
    this.SubService.activate({
      id: sub._id,
    },  {}, _ => {
      this.getData();
    }, err => {console.log(err)});
  }

  deactivate(sub) {
    this.SubService.deactivate({
      id: sub._id,
    }, {},  _ => {
      this.getData();
    }, err => {console.log(err)});
  }

  delete(sub) {

    var subStr = "<br/><br/><b>" + sub.firstName + ' ' + sub.lastName + ' ' + sub.companyName + "</b>";
    var dlg = this.dialogs.confirm("Delete sub (request)?", "Do you really want to delete this sub (request)?" + subStr);
    dlg.result.then(() => {
      this.SubService.delete({id: sub._id}, _ => {
        this.getData();
      })
    }, () => {
      // Cancel
    });

  }
}

export default angular.module('conduuApp.subAdmin', [uiRouter])
  .config(routes)
  .component('subAdmin', {
    template: require('./sub-admin.html'),
    controller: SubAdminComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/sub/admin/sub-admin.component.js